
import { ColliClient } from '@frontend/colli/api';
import { Colli } from '@frontend/colli/types';
import { EntityType } from '@frontend/common';
import { useReactiveObject, useReactiveObjects, useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useColli:request': CustomEvent<string>;
    }
}

const REQUEST_COLLI_EVENT = 'useColli:request';
const STORAGE_KEY = 'COLLI_REQ';

export function colliRequest(colliId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_COLLI_EVENT, { detail: colliId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function ColliResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_COLLI_EVENT, EntityType.COLLI, (ids) => ColliClient.resolveCollis(ids), props.dispatch);
    return <></>;
}

interface UseColliResolverProps {
    colliId?: string;
    fetchOnload?: boolean;
}
interface UseColliResolverReturn {
    colli: Colli | null;
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description ColliResolver must be present in the app for this to work.
 */
export function useReactiveColli({ colliId, fetchOnload = false }: UseColliResolverProps): UseColliResolverReturn {
    const { object: colli, initialising, isLoading } = useReactiveObject<Colli>({ id: colliId, entity_type: EntityType.COLLI, fetchOnload, resolveFunction: colliRequest });
    return { colli, initialising, isLoading };
}

interface UseCollisResolverProps {
    colliIds?: string[];
    fetchOnload?: boolean;
}
interface UseCollisResolverReturn {
    collis: Colli[];
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description ColliResolver must be present in the app for this to work.
 */
export function useReactiveCollis({ colliIds, fetchOnload = false }: UseCollisResolverProps): UseCollisResolverReturn {
    const { objects: collis, initialising, isLoading } = useReactiveObjects<Colli>({ ids: colliIds, entity_type: EntityType.COLLI, fetchOnload, resolveFunction: colliRequest });
    return { collis, initialising, isLoading };
}
